import { RootStateOrAny, useDispatch, useSelector } from 'react-redux'
import { EMAIL_SUPPORT_RESET } from '../../constants/emailConstants'
import ToastMessage from '../ToastMessage/ToastMessage'

const ContactSupportToast = () => {
  const dispatch = useDispatch()

  const { success } = useSelector((state: RootStateOrAny) => state.emailSupport)

  const onClose = (bool: boolean) => {
    if (!bool) dispatch({ type: EMAIL_SUPPORT_RESET })
  }

  return (
    <ToastMessage
      message={
        <>
          <p className="fs16 fw600">Message sent.</p>
          <p className="fs14 m-b-0">
            Your message has been successfully delivered.
          </p>
        </>
      }
      open={success}
      setOpen={onClose}
    />
  )
}

export default ContactSupportToast
